import React from 'react'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { Comment } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import ActionIconsContainer from './ActionIconsContainer'

type ReplyIconProps = {
  postId: string
  displayText?: boolean
  iconColor?: string
}

const ReplyIcon = ({ postId, displayText = true, iconColor }: ReplyIconProps) => {
  const { t } = useTranslation()
  const theme = useDisplayTheme() as Theme
  const color = iconColor || sys[theme].text.placeholder

  return (
    <ActionIconsContainer
      tooltipContent={t('reply')}
      message={displayText ? t('reply') : ''}
      url={`https://twitter.com/intent/tweet?in_reply_to=${postId}`}>
      <Comment color={color} />
    </ActionIconsContainer>
  )
}

export default ReplyIcon
